import ProgressBar from "components/ProgressBar"
import {currency, translate} from 'filters'
import _ from "lodash"
import React from "react"
import Trans from '../../Trans'

type HighestBidStatisticProps = {
  sumBids: number,
  bidLimit: number
}

type HighestBidStatisticState = {
  step: number
}

export default class HighestBidStatistic extends React.Component<HighestBidStatisticProps, HighestBidStatisticState> {
  constructor(props: HighestBidStatisticProps) {
    super(props)
    this.state = {
      step: _.round(props.sumBids / (props.bidLimit / 7))
    }
  };

  render() {
    return (
      <div className='statistic_box rounded'>
        <div className='statistic_box_body'>
          <h2>{translate("Summe Höchstbietende Fahrzeuge")}</h2>
          <p>{translate("Summe aller Höchstbietenden Gebote.")}</p>
          <div className='stat flex flex-col w-full justify-center items-center'>
            <span>{currency(this.props.sumBids)}</span>
            <ProgressBar step={'step-' + (this.state.step > 7 ? 7 : this.state.step)} valueNow={(this.props.sumBids / this.props.bidLimit) * 100}/>
          </div>
        </div>
      </div>
    )
  }
}
